import { PropsWithChildren, ReactNode } from 'react'
import { useIntl } from 'react-intl'

import ConfirmModal from 'components/Modal/ConfirmModal'
import { commonMessages } from 'app/i18n/messages'

interface ConfirmDeleteModalProps {
  handleConfirm: () => void
  handleDiscard: () => void
  isOpen: boolean
  title: ReactNode
}

function DeleteHomeConfigModal({
  children,
  handleConfirm,
  handleDiscard,
  isOpen,
  title,
}: PropsWithChildren<ConfirmDeleteModalProps>) {
  const { formatMessage } = useIntl()

  return (
    <>
      <ConfirmModal
        isOpen={isOpen}
        onDiscard={handleDiscard}
        title={title}
        discardBtnTitle={formatMessage(commonMessages.cancel)}
        confirmBtnTitle={formatMessage(commonMessages.delete)}
        onConfirm={handleConfirm}
        variant="primary"
      >
        {children}
      </ConfirmModal>
    </>
  )
}

export default DeleteHomeConfigModal
